import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import ButtonStyles from './styled';
import PlayCircleIcon from '../Icons/PlayCircle';

const LinkVideo = ({
  to,
  children,
  isExternal = false,
  newTab = false,
  className,
  ...props
}) =>
  isExternal ? (
    <a
      href={to}
      target={newTab ? '_blank' : '_self'}
      className={`${className} link`}
      {...props}
    >
      <PlayCircleIcon />
      {children}
    </a>
  ) : (
    <RouterLink to={to} className={`${className} link`} {...props}>
      <PlayCircleIcon />
      {children}
    </RouterLink>
  );

LinkVideo.propTypes = {};

export default ButtonStyles(LinkVideo);
